var _path, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCustomiconLibrary = function SvgCustomiconLibrary(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#customicon-library_svg__a)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "customicon-library_svg__b",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 20,
    height: 20
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20 0H0v20h20V0Z",
    fill: "#fff"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#customicon-library_svg__b)",
    fill: "#5457FF"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10 16.855a.501.501 0 0 1-.5-.5c0-.766-.626-1.39-1.39-1.39H4.04a.501.501 0 0 1-.5-.5V2.744c0-.14.06-.275.16-.37a5.208 5.208 0 0 1 6.594-.37.5.5 0 0 1 .205.405v13.945c0 .274-.225.5-.5.5Zm-5.46-2.89h3.57c.52 0 1 .165 1.39.444V2.67a4.21 4.21 0 0 0-4.96.3V13.965Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10 16.855a.501.501 0 0 1-.5-.5 2.39 2.39 0 0 1 2.39-2.39h3.57V2.97a4.205 4.205 0 0 0-5.166-.155.498.498 0 0 1-.7-.11.498.498 0 0 1 .11-.7c2-1.465 4.77-1.31 6.595.37.105.095.16.23.16.37v11.72c0 .274-.225.5-.5.5h-4.07c-.765 0-1.39.624-1.39 1.39 0 .274-.225.5-.5.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10 19.374A2.683 2.683 0 0 1 7.37 17.2H1.94a.501.501 0 0 1-.5-.5V2.744c0-.275.224-.5.5-.5h2.1c.274 0 .5.225.5.5s-.226.5-.5.5h-1.6V16.2h5.384c.275 0 .5.225.5.5a1.675 1.675 0 0 0 3.35 0c0-.275.226-.5.5-.5h5.38V3.244h-1.6a.501.501 0 0 1-.5-.5c0-.275.226-.5.5-.5h2.1c.276 0 .5.225.5.5V16.7c0 .275-.224.5-.5.5h-5.43a2.678 2.678 0 0 1-2.63 2.175H10Z"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "customicon-library_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h20v20H0z"
  })))));
};
export default SvgCustomiconLibrary;